import React, { useState, useRef, useEffect, Fragment } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import { default_article } from "../constants/default";
import ArticleForm from "./ArticleForm";
import Firebase from "../../../firebasehelper";
import { isDeepEqual } from "../../../functions";
import "./EditArticleModal.css";

const EditArticleModal = ({
  initial,
  onUpdate,
  brand,
  deleteArticleBtnRef,
  setArticleIdToDelete,
}) => {
  const [isPostable, setIsPostable] = useState(false);
  const dismissElement = useRef();
  const [article, setArticle] = useState(initial ? initial : default_article);
  const [events, setEvents] = useState([]);
  const [products, setProducts] = useState([]);
  const [liveTasks, setLiveTasks] = useState([]);
  const [toMembers, setToMembers] = useState(true);
  const [isPublic, setIsPublic] = useState(true);
  const [toReferrals, setToReferrals] = useState(true);
  const [loading, setLoading] = useState(false);
  // const brand = useSelector((state) => state.brand);
  useEffect(() => {
    setArticle(initial);
  }, [initial]);
  useEffect(() => {
    if (brand) {
      if (brand.name) {
        Firebase.getAllEvents(brand.name, (events) => setEvents(events));
        Firebase.getEcoPackages((products) => {
          let bPckgs_ids = Object.keys(products);
          const pkgs = bPckgs_ids.map((id) => ({ ...products[id], id }));
          const brand_packages = brand.packages;
          let brandPckgs_ids = brand_packages
            ? Object.keys(brand_packages)
            : [];
          const b_pkgs = brandPckgs_ids.map((id) => ({
            ...brand_packages[id],
            id,
          }));
          setProducts([
            ...pkgs.filter((item) => item.active),
            ...b_pkgs.filter((item) => item.active),
          ]);
        });
        Firebase.getAllTokenEarnings((tokenEarnings) => {
          // get live tasks
          let super_tokenEarnings = tokenEarnings.filter((obj) => !obj.brand);
          let brand_tokenEarnings = tokenEarnings.filter((obj) =>
            obj.brand
              ? obj.brand.toLowerCase() === brand.name.toLowerCase()
              : false
          );
          let total_tokenEarnings =
            super_tokenEarnings.concat(brand_tokenEarnings);
          setLiveTasks(total_tokenEarnings);
          // Firebase.getAllHotTasks(brand.name, (hot_tasks) => {
          //   const result = total_tokenEarnings.filter((item) =>
          //     hot_tasks.includes(item.id)
          //   );
          //   console.log("live tasks", result);
          //   setLiveTasks(result);
          // });
        });
      }
    }
  }, [brand]);

  // useEffect(() => {
  //   const { title, leadMedia, leadParagraph } = article;
  //   if (title && leadMedia && leadParagraph) setIsPostable(true);
  //   else setIsPostable(false);
  // }, [article]);
  const handleClickClose = () => {
    dismissElement.current.click();
  };
  const handleClickUpdate = () => {
    onUpdate(article);
    dismissElement.current.click();
  };
  const handleChangeArticle = (value) => {
    const newArticle = _.cloneDeep(value);
    if (!isDeepEqual(article, newArticle)) {
      setArticle(newArticle);
    }
  };
  return (
    <div
      className="modal fade"
      id="edit_article_modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div
        className="modal-dialog"
        role="document"
        style={{ maxWidth: "600px" }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit article</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              ref={dismissElement}
              onClick={handleClickClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body pb-1 ">
            <ArticleForm
              onChangeArticle={handleChangeArticle}
              article={article ? article : default_article}
              updateArticle={setArticle}
              events={events}
              products={products}
              liveTasks={liveTasks}
              hex={brand ? brand.hex : "#fff"}
              white={brand ? brand.white : false}
              handleLoading={(isLoading) => setLoading(isLoading)}
              toMembers={toMembers}
              setToMembers={setToMembers}
              toReferrals={toReferrals}
              setToReferrals={setToReferrals}
              isPublic={isPublic}
              setIsPublic={setIsPublic}
            />
          </div>
          <div className="modal-footer footer-container">
            <div className="btn-action-container">
              <Fragment>
                <button
                  className="btn btn-delete"
                  data-dismiss="modal"
                  onClick={() => {
                    setArticleIdToDelete(article.id);
                    deleteArticleBtnRef.current.click();
                  }}
                >
                  Delete X
                </button>
                <div className="footer-subcontainer">
                  <button
                    type="button"
                    className="btn btn-brand-hex btn-white"
                    style={{
                      "--hover-text-color": brand.white ? "white" : "black",
                      "--hover-color": brand.hex,
                      backgroundColor: "white",
                      color: "black",
                    }}
                    data-dismiss="modal"
                  >
                    Update Later
                  </button>
                  <button
                    type="button"
                    className="btn btn-green"
                    data-dismiss="modal"
                    disabled={
                      JSON.stringify(article) === JSON.stringify(initial) ||
                      loading
                    }
                    onClick={handleClickUpdate}
                  >
                    Update
                  </button>
                </div>
              </Fragment>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditArticleModal;



// WEBPACK FOOTER //
// ./src/screens/Articles/components/EditArticleModal.js